<template>
  <div
    qaid="project-one-rail-layout"
    class="project-one-rail-layout"
    :style="viewBreakpointMoreThan('medium') ? height : ''"
  >
    <div id="canvas-slot" qaid="project-one-rail-layout-canvas">
      <div id="project-one-gallery" class="flex items-center justify-center h-full">
        <project-one-bike-image class="project-one-bike-image--fill-width-height" />
      </div>
    </div>
    <div id="right-rail" qaid="project-one-rail-layout-rail">
      <project-one-right-rail :base-properties="baseProperties" @on-backpress="$emit('on-backpress')" />
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import ProjectOneRightRail from '@/projectOne/components/rightRail/components/ProjectOneRightRail';
import ProjectOneBikeImage from '@/projectOne/components/shared/ProjectOneBikeImage';
import viewSize from '@/mixins/view-size';

export default {
  components: {ProjectOneBikeImage, ProjectOneRightRail},
  mixins: [viewSize],

  data() {
    return {};
  },

  computed: {
    height() {
      return `grid-template-rows: ${this.availableHeight}px`;
    },

    ...mapState('projectOne', ['availableHeight']),
  },
};
</script>

<style lang="scss" scoped>
.project-one-rail-layout {
  display: grid;
  grid-template-rows: auto 1fr;
}

@screen lg {
  .project-one-rail-layout {
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 1fr;
  }
}

@screen xxl {
  .project-one-rail-layout {
    grid-template-columns: 3fr 1fr;
  }
}

.project-one-bike-image--fill-width-height {
  @screen lg {
    height: 100%;
  }

  /deep/ > img {
    width: 100%;

    @screen lg {
      object-fit: contain;
      height: 100%;
    }
  }
}
</style>
